import { BulbOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { PromptsProps } from "@ant-design/x";
import React from "react";

    export const items: PromptsProps['items'] = [
        {
            key: '0',
            icon: <BulbOutlined style={{ color: '#FFD700' }} />,
            label: 'Word search',
            description: `Which reading has the word of 'cavity'?`,
        },
        {
            key: '1',
            icon: <InfoCircleOutlined style={{ color: '#1890FF' }} />,
            label: 'Reading Guidance - Where should I start?',
            description: 'Can you give me some high frequency words in the IELTS readings?',
        }
    ];